"use client";
import React from "react";
export function renderIcon(icon, className, props) {
    if (!icon) {
        return;
    }
    else if (React.isValidElement(icon)) {
        return React.cloneElement(icon, Object.assign({ className: [className, icon.props.className].filter(Boolean).join(" ") }, props));
    }
    else {
        return React.createElement(icon, Object.assign({ className }, props));
    }
}
export default renderIcon;
//# sourceMappingURL=render-icon.js.map